module.exports = __webpack_public_path__ + "media/images/sala-tinajas-928aa848e8affc605a16c75985f91caa.jpg";